import React, { PureComponent } from "react";
import { createChart, isBusinessDay, LineStyle } from "lightweight-charts";
import { map, forEach } from 'lodash';

class LightWeightChart extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {};
      this.containerId = `lightweight_chart_container${this.props.index}`;
    }
    // static defaultProps = {
  
    chart = null;
  
    componentDidMount() {
      const chart = createChart(this.containerId, {
        width: 120,
        height: 75,
      });
      this.chart = chart;
      chart.applyOptions({
        grid: {
          vertLines: {
            color: "white",
            style: LineStyle.Dashed,
            visible: true,
          },
          horzLines: {
            color: "white",
            style: LineStyle.Dashed,
            visible: true,
          },
        },
        layout: {
          textColor: "red",
        },
        timeScale: {
          borderColor: "red",
          timeVisible: true,
          borderVisible: false,
          tickMarkFormatter: (time, tickMarkType, locale) => {
            //console.log(time, tickMarkType, locale);
            return "";
          },
        },
        priceScale: {
          position: "none",
          borderVisible: false,
        },
  
        crosshair: {
          vertLine: {
            color: "red",
            visible: false,
            labelVisible: false,
          },
          horzLine: {
            color: "red",
            visible: false,
            labelVisible: false,
          },
        },
        watermark: {
          color: "red",
          visible: false,
          text: "TradingView Watermark Example",
          fontSize: 24,
          horzAlign: "left",
          vertAlign: "bottom",
        },
      });
      const lineSeries = chart.addAreaSeries();
  
      let dataForChart = [];
      forEach(this.props.dataChart, (data) => {
        dataForChart.push({ time: data.created_at / 1000, value: data.price });
      });
  
      lineSeries.setData(dataForChart);
      lineSeries.applyOptions({
        lineWidth: 0.5,
        priceLineColor: "#5f5890",
        lineColor: "#5f5890",
        topColor: "#5f5890",
      });
      chart.timeScale().fitContent();
    }
  
    componentWillUnmount() {
      if (this.chart !== null) {
        this.chart.remove();
        this.chart = null;
      }
    }
  
    render() {
      return (
        <div
          style={{ color: "black", display: "flex", width: "100%" }}
          id={this.containerId}
          className={"LightWeightChart"}
        ></div>
      );
    }
  }


  export default LightWeightChart;
